import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "yc7lmngr",
  dataset: "production",
  useCdn: true,
  apiVersion: "2024-07-12",
});
